export const ua = window.navigator.userAgent.toLowerCase();
